import { combineTextDescendants } from './utilities.mjs';

/**
 * Deserialize HTML to Element.
 */
function deserializeHTMLToElement({
  plugins,
  element,
  children
}) {
  let slateElement;
  let withoutChildren;
  plugins.some(({
    deserialize: pluginDeserializers
  }) => {
    if (!(pluginDeserializers != null && pluginDeserializers.element)) {
      return false;
    }
    return pluginDeserializers.element.some(deserializer => {
      const deserialized = deserializer.deserialize(element);
      if (!deserialized) {
        return false;
      }
      slateElement = deserialized;
      withoutChildren = deserializer.withoutChildren;
      return true;
    });
  });
  if (slateElement) {
    let descendants = children;
    if (!descendants.length || withoutChildren) {
      descendants = [{
        text: ''
      }];
    }
    return {
      ...slateElement,
      children: combineTextDescendants(descendants)
    };
  }
  return undefined;
}

export { deserializeHTMLToElement };
